/** Defines how values should be pasted into the destination table, whether they're added to the end or replace existing values */
export enum AddFromStructuredTablePasteOption {
  APPEND = 'append',
  REPLACE = 'replace',
}
